import { action, createRequestTypes } from "../../actions";

export const GAME = createRequestTypes("GAME");
export const PREPARE_GAME = createRequestTypes("PREPARE_GAME");
export const GAMES = createRequestTypes("GAMES");

export const loadGame = {
  request: token => action(GAME.REQUEST, { token }),
  success: game => action(GAME.SUCCESS, { data: game }),
  failure: error => action(GAME.FAILURE, error),
  initial: () => action(GAME.INITIAL),
};

export const loadGames = {
  request: lang => action(GAMES.REQUEST, { lang }),
  success: games => action(GAMES.SUCCESS, { data: games }),
  failure: error => action(GAMES.FAILURE, error),
};

export const prepareGame = {
  request: (id, user_id, token, lang) => action(PREPARE_GAME.REQUEST, { id, user_id, token, lang }),
  success: (game, token) => action(PREPARE_GAME.SUCCESS, { data: game, token }),
  failure: error => action(PREPARE_GAME.FAILURE, error),
};
